import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createEventReminderService, type ReminderPayload } from '@/services/events'
import { eventDetailsQueryKey } from './useEventDetails'

export const useCreateEventReminder = (agendaId: string, eventId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: ReminderPayload) => createEventReminderService(agendaId, eventId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: eventDetailsQueryKey(agendaId, eventId) })
      queryClient.invalidateQueries({ queryKey: ['calendar'] })
    },
  })
}
